// The desktop source manager, wired to the app: cameras.js opens and publishes, the camera slice hears about failures.
import { openCamera, openScreen, reportCameraError, showSourceStream } from '~/lib/cameras'
import { IS_DEV } from '~/lib/constants'
import store from '~/store'
import { setCameraLoading } from '~/store/camera'
import { createSourceManager, kindOf } from './manager'
import { onHold } from './textures'

const sourceManager = createSourceManager({
	open: id => (id === 'screen' ? openScreen() : openCamera(id)),
	show: showSourceStream,
	lost: (id, error) => {
		if (error && id !== 'screen') reportCameraError(id, error)
	},
	loading: on => store.dispatch(setCameraLoading(on)),
})

// A held source stays open past its stage release. Only one already live is kept, never opened; a release lingers so an interrupt reversing onto it re-stages it before it closes.
const HOLD_LINGER_MS = 1000
// The holds that took a ref: only those release one.
const kept = new Set()
onHold((id, held, token) => {
	if (!kindOf(id)) return
	if (held) {
		if (sourceManager.state(id) !== 'ready') return
		kept.add(token)
		sourceManager.acquire(id)
		return
	}
	if (!kept.delete(token)) return
	setTimeout(() => sourceManager.release(id), HOLD_LINGER_MS)
})

if (IS_DEV) window.sources = sourceManager

if (import.meta.hot) import.meta.hot.dispose(() => sourceManager.dispose())

export default sourceManager
